if($('footer#footer').length){
    $('.login-widget #customerLogin').prepend($('footer#footer .loginForm'))
    $('.footer-bottom').insertAfter('footer#footer').wrap('<div class="underFooter"></div>')
    $('#signature').append('<span class="signatureFirm"> | <a href="https://www.d2solutions.cz/" target="_blank">D2solutions</a> | <a href="https://www.shopcode.cz/" target="_blank">ShopCode</a></span>')
    $('footer#footer').before($('footer#footer .customInstagram'))    
    $('footer#footer').after($('footer#footer .dotationText'))
    $('footer#footer .contact-box ul').append($('footer#footer .adress'))
    $('footer#footer .contact-box').append('<ul class="superSocial"></ul>')
    $('footer#footer .contact-box span.tiktok a').attr('href', 'https://'+$('footer#footer .contact-box span.tiktok a').attr('href').split('@')[1]).closest('span').removeClass('tiktok').addClass('pinterest')
    $('footer#footer .contact-box span.facebook').closest('li').appendTo('.superSocial')
    $('footer#footer .contact-box span.instagram').closest('li').appendTo('.superSocial')

    $('footer#footer .contact-box span.pinterest').closest('li').appendTo('.superSocial')
    $('footer#footer .contact-box span.youtube').closest('li').appendTo('.superSocial')
    $(".instagram-widget>a").each(function(){

        $(".instagramFeed").append('<div class="igPost"><a href="'+$(this).attr("href")+'" target="_blank" style="background-image: url('+$(this).find("img").attr("data-src")+')"></a></div>')
    })
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    })
}